import React from 'react';
import { PillIcon, ThermometerIcon, HeartIcon, BrainIcon, ActivityIcon } from 'lucide-react';
export function MedicationFinder() {
  const symptoms = [{
    icon: <ThermometerIcon className="w-6 h-6" data-id="element-5282" data-mp="1j7c4hpf45j6b" />,
    name: 'Fever & Pain',
    color: 'bg-red-100 text-red-600'
  }, {
    icon: <HeartIcon className="w-6 h-6" data-id="element-5283" data-mp="1f6sagupu6voe" />,
    name: 'Cold & Flu',
    color: 'bg-blue-100 text-blue-600'
  }, {
    icon: <BrainIcon className="w-6 h-6" data-id="element-5284" data-mp="rgoacxbuxe25" />,
    name: 'Headache',
    color: 'bg-purple-100 text-purple-600'
  }, {
    icon: <ActivityIcon className="w-6 h-6" data-id="element-5285" data-mp="mf8oj31uv3ip" />,
    name: 'Allergies',
    color: 'bg-green-100 text-green-600'
  }, {
    icon: <PillIcon className="w-6 h-6" data-id="element-5286" data-mp="vhhv5hu06cqt" />,
    name: 'Digestive',
    color: 'bg-yellow-100 text-yellow-600'
  }, {
    icon: <ThermometerIcon className="w-6 h-6" data-id="element-5287" data-mp="7qm7mwwky3pd" />,
    name: 'Skin Care',
    color: 'bg-pink-100 text-pink-600'
  }];
  return <div className="container mx-auto px-4 py-8" data-id="element-5288" data-mp="3or6bsenfqbl">
      <div className="bg-gradient-to-br from-[#1E2B55] to-[#162041] rounded-2xl p-8 text-white relative overflow-hidden" data-id="element-5289" data-mp="1akogaa5qh7hm">
        <div className="absolute inset-0 opacity-10" data-id="element-5290" data-mp="1fiznse8k35wo">
          <div className="absolute inset-0" style={{
          backgroundImage: 'url(\'data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="1"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\')'
        }} data-id="element-5291" data-mp="1kazk7wpf3goi"></div>
        </div>
        <div className="relative z-10" data-id="element-5292" data-mp="16k4hz39fbxtw">
          <div className="text-center mb-8" data-id="element-5293" data-mp="16l5w5glql0fu">
            <span className="inline-block bg-white text-[#1E2B55] text-xs font-bold px-4 py-1.5 rounded-full mb-4" data-id="element-5294" data-mp="16hrs83xfcj6a">
              MEDICATION FINDER
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-5295" data-mp="2hxq6cm7glved">
              What's bothering you?
            </h2>
            <p className="text-blue-100 text-lg max-w-2xl mx-auto" data-id="element-5296" data-mp="hz4phwm24d9m">
              Select your symptom to find the right medication with expert
              guidance
            </p>
          </div>
          {/* Symptom Selection Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-5297" data-mp="mvld8ppcgpm6">
            {symptoms.map((symptom, index) => <button key={index} className="bg-white text-gray-900 rounded-xl p-6 hover:shadow-lg transition-all transform hover:scale-105" data-id="element-5298" data-mp="3vcpyp7ouxevx" data-mpi={index}>
                <div className={`w-14 h-14 ${symptom.color} rounded-full flex items-center justify-center mx-auto mb-3`} data-id="element-5299" data-mp="7zvwb5z0n2ob">
                  {symptom.icon}
                </div>
                <div className="text-sm font-medium" data-id="element-5300" data-mp="3bmmgj4x6qqlh">{symptom.name}</div>
              </button>)}
          </div>
        </div>
      </div>
    </div>;
}